exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{\n   -webkit-box-flex: 1;\n       -ms-flex: 1 0 auto;\n           flex: 1 0 auto;\n   -webkit-flex: 1 0 auto;\n   min-height: 200px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main